/**
 *
 * HoverMarker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { withLeaflet } from 'react-leaflet';
import withEdit from 'containers/EditService/withEdit';
import DraggableCircleMarker from 'components/DraggableCircleMarker';
import getSnap from 'utils/getSnap';
/**
 * prop event always indicates whether marker is still on path
 * if off path, check distance to previous point and remove leg if too far
 */

class HoverMarker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { leg: null };
    this.listening = false;
  }

  static getDerivedStateFromProps(props, state) {
    const { event, workingRoute, leg } = props;
    if (event && event.type === 'mouseover' && !state.leg) {
      return { leg, latlng: event.latlng, lastPos: event.latlng };
    }
    if (state.leg && !workingRoute[state.leg.id]) {
      return { leg: null };
    }
    return null;
  }

  componentDidMount() {
    const { leaflet } = this.props;
    const { leg } = this.state;
    this.snap = getSnap(leaflet.map);
    this.eventSource = leaflet.map;
    if (leg) {
      this.startListener();
    }
  }

  componentDidUpdate() {
    const { leg } = this.state;
    if (leg && !this.listening) {
      this.startListener();
    }
  }

  nearBounds() {
    const { leg, latlng } = this.state;
    return (
      this.snap.isClose([latlng, leg.lastPoint]) ||
      this.snap.isClose([latlng, leg.points[0]])
    );
  }

  startListener = () => {
    this.eventSource.addEventListener('mousemove', this.handleMove);
    this.eventSource.addEventListener('mousedown', this.stopListener); // start dragging
    this.listening = true;
  };

  stopListener = () => {
    this.eventSource.removeEventListener('mousemove', this.handleMove);
    this.eventSource.removeEventListener('mousedown', this.stopListener);
    this.listening = false;
  };

  handleMove = ev => {
    const { leg, lastPos, latlng } = this.state;
    const onPath =
      leg &&
      this.snap.isClose([latlng, lastPos]) &&
      !this.nearBounds(latlng, leg);
    if (onPath) {
      this.setState({ latlng: ev.latlng });
      return;
    }
    this.stopListener();
    this.setState({ leg: null });
  };

  handleDrag = ev => {
    const { onDrag } = this.props;
    const { leg } = this.state;
    onDrag({ legId: leg.id, latlng: ev.latlng, isMarker: false });
  };

  handleClick = ev => {
    const { onClick } = this.props;
    const { leg } = this.state;
    if (leg) {
      onClick(leg)(ev);
      // this.setState({ leg: null });
    }
  };

  handleDragEnd = ev => {
    const { insertPoint, travelMode, onDrag } = this.props;
    onDrag(null);
    const { leg } = this.state;
    const position = ev.target.getLatLng();
    insertPoint(leg.id, { ...position, snap: this.snap }, travelMode);
  };

  render() {
    const { leg, latlng } = this.state;
    if (!leg || this.nearBounds()) {
      return null;
    }
    return (
      <DraggableCircleMarker
        center={latlng}
        className="edit-icon-hover"
        draggable
        onDragend={this.handleDragEnd}
        onClick={this.handleClick}
        onDrag={this.handleDrag}
      />
    );
  }
}

HoverMarker.propTypes = {
  insertPoint: PropTypes.func.isRequired,
  travelMode: PropTypes.string.isRequired,
  leaflet: PropTypes.object.isRequired,
  leg: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
  workingRoute: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  event: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};

export default compose(
  withLeaflet,
  withEdit,
)(HoverMarker);
